import {PAID_PLAN_IDS, type PaidPlanId} from "./planCatalogue";

/**
 * The pricing route's one-click checkout intent (kitecorp/transferify-api-service#1192):
 * `/pricing?upgrade=<plan>` opens the EXISTING upgrade action for that plan on arrival, exactly as if the
 * reader had pressed its card. The api's download-limit notice builds this link
 * (`DownloadLimitEmail.UPGRADE_PARAMETER`) so an emailed sender lands in checkout in one click, with no
 * second checkout built for it. This module is deliberately independent of React.
 *
 * The parameter rides the QUERY, not the fragment: it carries no credential (a plan id is public
 * catalogue vocabulary), and the pricing page is pre-rendered, so nothing server-side ever acts on it.
 */
export const UPGRADE_INTENT_PARAMETER = "upgrade";

/**
 * Parses the intended plan out of a `location.search`-style string; null when absent or not a paid
 * plan id. Only the catalogue's own ids are honoured, so a typo or a stale tier name opens nothing
 * rather than something.
 */
export function parseUpgradeIntent(search: string): PaidPlanId | null {
	const value = new URLSearchParams(search.replace(/^\?/, "")).get(UPGRADE_INTENT_PARAMETER);
	return PAID_PLAN_IDS.find((id) => id === value) ?? null;
}

/** The same `location.search`, with the consumed intent removed so a reload does not re-open checkout. */
export function withoutUpgradeIntent(search: string): string {
	const params = new URLSearchParams(search.replace(/^\?/, ""));
	params.delete(UPGRADE_INTENT_PARAMETER);
	const rest = params.toString();
	return rest.length === 0 ? "" : `?${rest}`;
}
